import { Component, OnInit } from '@angular/core';
import { ServicesService } from '../services/services.service';
import {environment} from '../../environments/environment';
import swal from 'sweetalert2';
import { Router, ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-health-information',
  templateUrl: './health-information.component.html',
  styleUrls: ['./health-information.component.css']
})
export class HealthInformationComponent implements OnInit {

  apiBaseUrl = environment.apiBaseUrl;
  apiUrl = environment.apiUrl;
  
  toiletData = {
    toilet_type: 1,
    toilet_number: 1,
    toilet_grade: 1,
    image_1: '',
    image_2: '',
    image_3: ''
  }
  apiName : string = "/get-health-checks-pdf?id=";
  construction_id: number;
  spinLoader = {
    filter : false,
    delete : [],
    pageLoaded: false
  };
  constructor(private activeroute: ActivatedRoute,private _services: ServicesService, private router: Router) { 
    this.activeroute.queryParams.subscribe(params => {
      this.construction_id = params['construction_id'];
      this.toiletData.toilet_type = params['type'];
      this.toiletData.toilet_number = params['number'];
      this.toiletData.toilet_grade = params['grade'];
      this.toiletData.image_1 ="https://amalooloo.group/images/"+params['image_1'];
      this.toiletData.image_2 ="https://amalooloo.group/images/"+params['image_2'];
      this.toiletData.image_3 = "https://amalooloo.group/images/"+params['image_3'];

      //console.log("construction", this.construction_id)
    });
  }

  ngOnInit() {
  }

  imageModalShow(image_url) {
    // let img_name = this.apiBaseUrl + image_url;
    let img_name = image_url; 
    swal({
      title: 'Daily Health Check',
      html: `<img src="${img_name}" class="img-responsive">`,
      showCancelButton: false,
      showConfirmButton: false,
    })
  }
}
